<template>
  <Button class="theme-toggle" variant="outline" color="neutral" size="sm" type="button" @click="toggleTheme">
    <span class="screen-reader-only">Toggle theme</span>
    <span class="theme-toggle-label">{{ nextLabel }}</span>
  </Button>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { Button } from "../ui";
import { useThemePreference } from "../composables/useThemePreference";

const { currentMode, setThemeMode } = useThemePreference();

const nextLabel = computed(() =>
  currentMode.value === "light" ? "Dark" : "Light"
);

async function toggleTheme() {
  await setThemeMode(currentMode.value === "light" ? "dark" : "light");
}
</script>
